const isAdmin = (user) => {
  return user && user.role_name === "Admin";
};

export default isAdmin;
